var _defs, _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _rect2, _polygon, _rect3, _path38, _path39, _path40, _path41, _path42, _rect4, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _rect5, _polygon2, _polygon3, _polygon4, _polygon5, _path52, _polygon6, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _rect6, _rect7, _rect8, _rect9, _path60, _rect10, _rect11, _rect12, _g, _path61, _path62;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 3000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 2260.25,
    x2: 2238.12,
    y1: 907.82,
    y2: 636.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9d1c20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec2224"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M2267.85,666.43c26.17-15.74,72.1-35.51,106.39-7.65,84.49,68.6-47.2,187.1-108,248.12-11.27,11.32-22.67,11.37-35.14-.38-59.69-56.21-191.22-177.58-110.51-249.19,32.49-28.81,77.72-9.09,104.43,7.41,17.94,11.08,24.38,12.8,42.84,1.69",
    clipRule: "evenodd"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ecf4ff",
    fillRule: "evenodd",
    d: "M1448.8,442.36C1335.64,484.72,1228.07,575.42,1143.34,660,966.89,836.1,940.56,873.12,722.89,1021,596,1107.14,496,1180,446.72,1277.48,308.29,1551.27,473.18,1847,818.69,1847H2223.25s165.22,3.76,285.78-142.58c408.63-496-269.12-1558.23-1060.23-1262.05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#555559",
    d: "M690.07,1200.3V872.11h31.72V1200.3c0,30.55,18.16,56.34,39.62,56.34s39.66-25.79,39.66-56.34V1082.88c0-47.37,28.71-84.48,65.39-84.48s65.4,37.11,65.4,84.48V1200.3c0,31.06,23.45,56.34,52.27,56.34h44.22v28.17H984.13c-46.31,0-84-37.89-84-84.51V1082.88c0-33.18-17.77-56.32-33.7-56.32s-33.69,23.14-33.69,56.32V1200.3c0,47.39-31.34,84.51-71.36,84.51s-71.34-37.12-71.34-84.51"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55.78,
    height: 42.25,
    x: 937.9,
    y: 1244.14,
    fill: "#45444b",
    transform: "rotate(-71.5 965.704 1265.235)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7aaac",
    fillRule: "evenodd",
    d: "M1846.41,1186.44c88.82,172.58,18.28,314.23,224.36,390.37,136.43,11,317.93-239.27,378.7-362.58,54.81-58.33,55.36-51,40.13-129.77-12.06-37.38-45.76-32.14-55.46-24.68,1.53-6.88-17.57-72.81-49.29-63.47,1.24,23.45,1,114.66-2.81,139.55l-.34.3c-30.36,26.92-244.82,228.37-249,228.11-29.36-1.83-167.21-415.81-345.68-457.4-21.39-12.2-3.1,196.19,59.43,279.57"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#485f87",
    fillRule: "evenodd",
    d: "M1828.61,774c13.2,128.08,117.18,378.34,147,657.36l170.53-87.81C2108.59,1126,2039.4,846,1828.61,774"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a4168",
    fillRule: "evenodd",
    d: "M1904.93,1031.16q5.37,16.11,10.75,32.86l11.64-13.58c8.16,38.15,15.13,81,21.13,127.31,14.89,59.06,33.69,168.27,41.16,238.07l45.18-14.94c-13.84-158.68-65.85-341.71-81.6-369.28Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#c3dcfa",
    fillRule: "evenodd",
    d: "M1981.85,1355.61c39.29-7.5,120.14-44.16,158.2-69.42,10.42,16.09,17,27.8,23,45.57-5.62,5.73-15.14,22.34-26.75,29.25-46.29,27.56-120.36,64.25-155.15,67.48Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#485f87",
    fillRule: "evenodd",
    d: "M1156.58,867.81c-24.44,22.94-21.23,94.48-34.69,123.27-45.37,97.1-62.08,168.5-6.53,318.14l69-80.39c34.1,159.52,47.64,401.89,54.52,628.43h762.48c.1-487.18,9-1044.82-204.62-1095.41-122.13-42.74-313.07-41-480.54,2.35-64.59,16.7-111.5,47.41-159.57,103.61"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7aaac",
    fillRule: "evenodd",
    d: "M1631.84,864.54,1591,859c-85.18-37.84-88.43-89.61-113-138.62h0l4-120.7h219.11c-1.33,4.79.47,110.76,1,168.85-6,54.31-46.88,69.93-70.18,96"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#000446",
    fillRule: "evenodd",
    d: "M1706.41,212.46A130.43,130.43,0,1,1,1576,342.89a130.43,130.43,0,0,1,130.43-130.43"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a4168",
    fillRule: "evenodd",
    d: "M1184.31,1228.83c34.1,159.52,47.64,401.89,54.52,628.43h81.53c-1.84-189.28-46.93-659.38-73.94-706.68Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#e16e73",
    fillRule: "evenodd",
    d: "M1700.83,689.45c.19,1.89.59,42.3.61,44.48v.1c-59.28,13.91-144.24-27.07-174.72-95.77Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7aaac",
    fillRule: "evenodd",
    d: "M1438.54,559.16c-24.33-57.22-39.58-166.84,28.7-224.14,42.48-47.37,121.48-47.46,195-39.95,46.47,4.75,97.57-27.66,125.21,72.22,33.32,120.45,19.82,261.37-65.25,324.47-63,46.71-189.94,1.37-236.51-67.9-16-23.79-33.51-32.72-47.11-64.7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#000446",
    fillRule: "evenodd",
    d: "M1655.42,356.05c-73.21,12.82-150.43,11.19-132.19,144.36,6.28,45.81,24.54,87.38-49,34.21-16.63-12-31.89,2-21.59,30.28,8.93,24.5,41,58.09,28.59,52-134.64-66.5-183.94-301.84-45.43-419.58,39.78-33.81,102.26-42.85,164-49.35,5.26-.55,14,.59,24.58-1.31,5.26-.93,12.9-4.28,17.07-5.67,157.56-52.7,219.56,179.12,14,215.11"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1685.8,1857.26H1511.68c0-97.93,234.77-98.19,234.77,0h-48.74c0-21.87-17.68-41-43.26-54.17,15.44,7.89,31.35,32.77,31.35,54.17"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#c3dcfa",
    fillRule: "evenodd",
    d: "M1634.34,862c-25.58,26.17-64.81,62.62-90.39,88.79-54-56.91-81.8-139.39-107.29-210.15,21.44-12.62,21.82-14.71,40.9-29.93,24.76,49.3,70.65,113.54,156.78,151.29"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#c3dcfa",
    fillRule: "evenodd",
    d: "M1634.34,862c25.25,25.78,67.46,47.27,92.7,73,12.1-48.7,4-137.8-6.34-194.88-10.3-9.67-7.47-4.92-19.54-13,3.46,69.85-40.41,105.15-66.82,134.87"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7aaac",
    fillRule: "evenodd",
    d: "M1186.8,860.81c-7.92,6.31-45.61,59.2-54.16,73.54-66.42,111.35-194.33,445.87-164.82,647,21.6,147.25,540.76,291.49,558.36,275.92,48.5-1.67,64.33.22,83.35-14,66.15-49.61-41.22-85.68-41.22-85.68s-351.86-207.27-393-228.4c-13.86-8.17,53.93-226.86,97-370.6,26.75-89.24,88.14-436.06-85.49-297.72"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7aaac",
    fillRule: "evenodd",
    d: "M1545.42,1857.25c89.27-.45,189,.72,215.44-.41-26.14-77.88-119.17-103.56-192.55-99.31-17.62,12-35.51,74.68-22.89,99.72"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#485f87",
    fillRule: "evenodd",
    d: "M1333.43,1043.1C1327.33,913.3,1291,750.84,1181,842.91c-96.28,80.65-170.75,360.09-206.57,523.6-12.23,55.84,217.8,94.15,231.49,73.5,50.73-76.55,70.72-267.06,127.47-396.91"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M972.51,1345.8,1217,1418.41q-11.82,32.53-23.62,65.06L960.86,1420Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#b4dbff",
    fillRule: "evenodd",
    d: "M1422.31,1073h0a5.35,5.35,0,0,1,5.33,5.33v38.2a5.35,5.35,0,0,1-5.33,5.33h0a5.35,5.35,0,0,1-5.33-5.33v-38.2a5.35,5.35,0,0,1,5.33-5.33"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#b4dbff",
    fillRule: "evenodd",
    d: "M1285.53,960.68h0a5.35,5.35,0,0,1-1.55,7.38L1252,989a5.34,5.34,0,0,1-7.38-1.55h0a5.35,5.35,0,0,1,1.55-7.38l32-20.89a5.35,5.35,0,0,1,7.38,1.55"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#b4dbff",
    fillRule: "evenodd",
    d: "M1650.44,1046h0a5.34,5.34,0,0,1-1.55,7.38l-32,20.89a5.35,5.35,0,0,1-7.38-1.54h0a5.34,5.34,0,0,1,1.55-7.37l32-20.89a5.34,5.34,0,0,1,7.38,1.54"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#b4dbff",
    fillRule: "evenodd",
    d: "M1766.87,1178h0a5.35,5.35,0,0,0,1.55,7.38l32,20.89a5.35,5.35,0,0,0,7.38-1.55h0a5.35,5.35,0,0,0-1.55-7.38l-32-20.89a5.36,5.36,0,0,0-7.38,1.55"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#b4dbff",
    fillRule: "evenodd",
    d: "M1359.26,1301.23h0a5.36,5.36,0,0,0,1.55,7.38l32,20.89a5.35,5.35,0,0,0,7.38-1.55h0a5.34,5.34,0,0,0-1.55-7.38l-32-20.89a5.35,5.35,0,0,0-7.38,1.55"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#b4dbff",
    fillRule: "evenodd",
    d: "M1621,1291.12h0a5.34,5.34,0,0,1,2.67,7.05L1608,1333a5.33,5.33,0,0,1-7,2.67h0a5.35,5.35,0,0,1-2.67-7L1614,1293.8a5.34,5.34,0,0,1,7-2.68"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#b4dbff",
    fillRule: "evenodd",
    d: "M1164.41,1118.58h0a5.34,5.34,0,0,1,7.5-.74l29.52,24.25a5.36,5.36,0,0,1,.73,7.51h0a5.35,5.35,0,0,1-7.5.73l-29.52-24.25a5.35,5.35,0,0,1-.73-7.5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#b4dbff",
    fillRule: "evenodd",
    d: "M1829.3,967.48h0a5.34,5.34,0,0,0,1.55,7.37l32,20.9a5.35,5.35,0,0,0,7.38-1.55h0a5.35,5.35,0,0,0-1.55-7.38l-32-20.89a5.35,5.35,0,0,0-7.38,1.54"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#b4dbff",
    fillRule: "evenodd",
    d: "M1821.73,1458.25h0a5.36,5.36,0,0,0,1.55,7.38l32,20.89a5.35,5.35,0,0,0,7.38-1.55h0a5.34,5.34,0,0,0-1.55-7.38l-32-20.89a5.34,5.34,0,0,0-7.38,1.55"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#b4dbff",
    fillRule: "evenodd",
    d: "M1542.34,1473.17h0a5.34,5.34,0,0,0,1.54,7.38l32,20.89a5.34,5.34,0,0,0,7.38-1.54h0a5.34,5.34,0,0,0-1.54-7.38l-32-20.89a5.34,5.34,0,0,0-7.38,1.54"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#b4dbff",
    fillRule: "evenodd",
    d: "M1574.71,1650h0a5.35,5.35,0,0,1-1.55,7.38l-32,20.89a5.36,5.36,0,0,1-7.38-1.55h0a5.35,5.35,0,0,1,1.55-7.38l32-20.89a5.34,5.34,0,0,1,7.38,1.55"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#b4dbff",
    fillRule: "evenodd",
    d: "M1796.34,1620.34h0a5.33,5.33,0,0,1-1.54,7.37l-32,20.9a5.34,5.34,0,0,1-7.37-1.55h0a5.35,5.35,0,0,1,1.55-7.38l32-20.89a5.34,5.34,0,0,1,7.38,1.54"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#b4dbff",
    fillRule: "evenodd",
    d: "M1376.85,1514.44h0a5.36,5.36,0,0,1,2.84,7l-14.87,35.19a5.35,5.35,0,0,1-7,2.83h0a5.34,5.34,0,0,1-2.84-7l14.87-35.19a5.36,5.36,0,0,1,7-2.84"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#b4dbff",
    fillRule: "evenodd",
    d: "M1336.14,830.38h0a5.35,5.35,0,0,0,1.55,7.38l32,20.89a5.34,5.34,0,0,0,7.38-1.55h0a5.35,5.35,0,0,0-1.55-7.38l-32-20.89a5.36,5.36,0,0,0-7.38,1.55"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#b4dbff",
    fillRule: "evenodd",
    d: "M1200.85,1309.7h0a5.35,5.35,0,0,0-7.5-.73l-29.51,24.25a5.34,5.34,0,0,0-.74,7.5h0a5.34,5.34,0,0,0,7.5.74l29.52-24.25a5.35,5.35,0,0,0,.73-7.51"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#b4dbff",
    fillRule: "evenodd",
    d: "M1047.92,1229h0a5.35,5.35,0,0,1,7.51-.73l29.51,24.25a5.34,5.34,0,0,1,.74,7.5h0a5.35,5.35,0,0,1-7.51.74l-29.51-24.25a5.35,5.35,0,0,1-.74-7.51"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#b4dbff",
    fillRule: "evenodd",
    d: "M1815.42,806h0a3.69,3.69,0,0,1-1.07,5.1l-22.11,14.45a3.71,3.71,0,0,1-5.1-1.07h0a3.7,3.7,0,0,1,1.07-5.1L1810.32,805a3.69,3.69,0,0,1,5.1,1.07"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 301.58,
    height: 314.38,
    x: 965.72,
    y: 1155.05,
    fill: "#7abbe2",
    transform: "matrix(.26 -.96 .96 .26 -443.79 2043.01)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#00719e",
    points: "1002.98 1131.5 1306.22 1214.44 1309.6 1202.09 1006.36 1119.15 1002.98 1131.5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 12.81,
    height: 314.39,
    x: 1070.28,
    y: 1300.47,
    fill: "#00719e",
    transform: "rotate(-74.7 1076.772 1457.685)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#58a9d2",
    d: "M1147.13,1280.26l-20.54,75.1c-12.16,44.44-41.81,77.66-74.89,88.85a76.74,76.74,0,0,1-12.62,3.18,71.24,71.24,0,0,1-20.46.38,67.36,67.36,0,0,1-9.17-1.84l-86-23.53,82.94-303.25,86,23.52a69.33,69.33,0,0,1,8.84,3.08,71.59,71.59,0,0,1,17.4,10.74,73.52,73.52,0,0,1,9.25,9.18c22.78,26.46,31.4,70.15,19.25,114.59"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#cfcecc",
    d: "M1020.55,1443.37l-7.42-2c.53.15,1.07.29,1.6.42l7.45,2-1.63-.42"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#00719e",
    d: "M1121.8,1376.35a155.11,155.11,0,0,0,5.61-14.7,155.11,155.11,0,0,1-5.61,14.7m-61.56,70.17-7.7-2.11c28.06-9.14,53.64-33.47,68.72-66.83-15.08,33.38-40.69,57.71-68.76,66.84a73.36,73.36,0,0,1-12.82,3.15,75.8,75.8,0,0,1-21.06.2,67.36,67.36,0,0,1-9.17-1.84l-86-23.53,3-11,86,23.54a56.64,56.64,0,0,0,12.51,2c39.09,2.21,79.26-33.27,93.48-85.29l19.77-72.26c14.25-52.13-2.29-103-37.06-121a55.34,55.34,0,0,0-11.79-4.65l-86-23.54,3-11,86,23.52a69.33,69.33,0,0,1,8.84,3.08,75.24,75.24,0,0,1,18,10.91,72.13,72.13,0,0,1,9.45,9.22l7.68,2.11c23.69,26.81,32.84,71.32,20.49,116.46l-19.76,72.26C1124.78,1401.73,1094.28,1435.37,1060.24,1446.52Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#00719e",
    d: "M1135.69,1173l-7.42-2a69.09,69.09,0,0,0-9.13-8.9,73.06,73.06,0,0,0-17.38-10.53,65.71,65.71,0,0,0-8.54-3l7.42,2a71.68,71.68,0,0,1,35,22.41"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#00719e",
    d: "M1022.18,1443.79l-7.45-2a69.05,69.05,0,0,0,7.26,1.36,72.87,72.87,0,0,0,20.33-.2,71.2,71.2,0,0,0,12.38-3h0l7.43,2-.05,0a71.53,71.53,0,0,1-12.37,3,70.69,70.69,0,0,1-27.57-1.15"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 43.61,
    height: 55.78,
    x: 683.84,
    y: 866.62,
    fill: "#45444b"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#9bcfe4",
    d: "M576.06,904.7a95.28,95.28,0,0,1-95.16-95.16V506.79a95.27,95.27,0,0,1,95.16-95.15H878.8A95.3,95.3,0,0,1,974,506.79V809.54a95.3,95.3,0,0,1-95.2,95.16Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#45444b",
    d: "M873,847.18H581.87a43.45,43.45,0,0,1-43.45-43.45V512.6a43.45,43.45,0,0,1,43.45-43.44H873a43.44,43.44,0,0,1,43.43,43.44V803.73A43.44,43.44,0,0,1,873,847.18"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#36363b",
    d: "M916.42,512.37a43.07,43.07,0,0,0-8.78-25.72c.14.12.3.23.44.34a43.14,43.14,0,0,1,8.34,25.38m0,.23v0ZM581.64,847.18a43.29,43.29,0,0,1-25.31-8.3c-.13-.17-.27-.34-.39-.53A42.86,42.86,0,0,0,581.64,847.18Zm.23,0h0Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#daecf0",
    d: "M844.52,760.3H610.33c-19.31,0-35-13.11-35-29.23V535.29c0-16.13,15.64-29.21,35-29.21H844.52c19.34,0,35,13.08,35,29.21V731.07c0,16.12-15.65,29.23-35,29.23"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#36363b",
    d: "M844.73,506.08h0m.21,0h0Zm.23,0h0Zm.17,0h0Zm-270,225.16v0Zm0,.19v0Zm0,.18v0Zm0,.14a.25.25,0,0,0,0-.08A.25.25,0,0,1,575.39,731.76Zm0,.17v0Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#9ca9aa",
    d: "M588.47,753.69c-7.69-5.16-12.77-12.89-13.08-21.76v-.17a.25.25,0,0,0,0-.08V535.29c0-16.13,15.64-29.21,35-29.21h235c12.88.24,23.95,6.4,29.75,15.26a39.28,39.28,0,0,0-21.86-6.58H619c-19.29,0-35,13.11-35,29.24V739.77a25.21,25.21,0,0,0,4.43,13.92"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2e3e2",
    d: "M655.06,802.62A26.08,26.08,0,1,1,629,776.55a26.08,26.08,0,0,1,26.07,26.07"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2e3e2",
    d: "M710.11,828.7a17.37,17.37,0,0,1-17.35-17.38V793.93a17.38,17.38,0,0,1,17.35-17.38h48.16V828.7Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2e3e2",
    d: "M815.07,828.7H767V776.55h48.11a17.38,17.38,0,0,1,17.38,17.38v17.39a17.38,17.38,0,0,1-17.38,17.38"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 8.69,
    height: 26.1,
    x: 624.63,
    y: 789.58,
    fill: "#555559"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#555559",
    points: "782.38 782.61 817.03 802.62 782.38 822.62 782.38 782.61"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#3a3a3a",
    points: "784.81 787.46 814.05 804.34 817.03 802.62 782.38 782.61 782.38 822.62 784.81 821.23 784.81 787.46"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#555559",
    points: "742.54 782.62 707.9 802.62 742.54 822.65 742.54 782.62"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#3a3a3a",
    points: "740.14 787.46 710.88 804.35 707.9 802.62 742.54 782.62 742.54 822.65 740.14 821.26 740.14 787.46"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#45444b",
    d: "M735.11,670.31a9.61,9.61,0,0,0-7.66,3.8A9.71,9.71,0,0,0,710,680c0,9.73,17.41,19.73,17.41,19.73S744.8,689.62,744.8,680a9.69,9.69,0,0,0-9.69-9.72"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#45444b",
    points: "674.49 736.6 674.47 736.6 672.21 734.74 661.91 683.98 652.43 715.94 650.17 717.61 616.97 717.61 616.97 712.92 648.42 712.92 660.12 673.69 662.47 672.03 664.63 673.89 674.63 723.19 682.11 690.45 684.35 688.59 684.39 688.59 686.65 690.38 692.29 712.92 749.39 712.92 749.39 717.61 690.45 717.61 688.19 715.83 684.48 700.99 676.8 734.8 674.49 736.6"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#45444b",
    d: "M771.69,571.07V530.71h-8.43a33,33,0,0,1-12.4,4.54v7.14h9.34v28.68H749.37v9.36h31.69v-9.36Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#45444b",
    d: "M813.09,570.68a73.76,73.76,0,0,0-8.32.66c8.06-8.46,15.89-17.39,15.89-25.79,0-9.54-6.66-15.75-16.45-15.75-7.08,0-11.69,2.67-16.63,7.93l6.24,6.14c2.52-2.65,5.25-5.11,8.79-5.11,4.35,0,7.1,2.64,7.1,7.51,0,7-8.94,15.58-21.59,27.52v6.64h34.94v-9.75Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#45444b",
    d: "M847.13,529.8c-10.65,0-17.75,8.72-17.75,25.56s7.1,26,17.75,26,17.8-9.12,17.8-26-7.13-25.56-17.8-25.56m0,42.63c-3.82,0-6.85-3.5-6.85-17.07s3-16.69,6.85-16.69,6.9,3.06,6.9,16.69S851,572.43,847.13,572.43Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#45444b",
    d: "M814.77,632.17v-.24c3.45-2.29,6.48-6.18,6.48-10.89,0-8.28-6-13.66-15.06-13.66-9.24,0-15.88,5.3-15.88,13.71,0,5.28,2.77,8.81,6.64,11.74v.33c-4.69,2.46-8.46,6.17-8.46,12.18,0,8.07,7.34,13.64,17.33,13.64,10.51,0,17.59-6,17.59-13.82,0-6.54-3.84-10.36-8.64-13m-8.83-16.79c3.77,0,6.06,2.59,6.06,6.43a11.06,11.06,0,0,1-3.06,7.25c-5.12-1.94-8.55-3.89-8.55-8C800.39,617.26,802.89,615.38,805.94,615.38ZM806,651c-4.17,0-7.67-2.6-7.67-7a10.77,10.77,0,0,1,3.85-7.82c6.24,2.64,10.51,4.26,10.51,8.63C812.7,649,809.85,651,806,651Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#45444b",
    d: "M847.13,607.38c-10.65,0-17.75,8.71-17.75,25.6s7.1,26,17.75,26,17.8-9.08,17.8-26-7.13-25.6-17.8-25.6m0,42.66c-3.82,0-6.85-3.52-6.85-17.06s3-16.68,6.85-16.68S854,619.41,854,633,851,650,847.13,650Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#45444b",
    d: "M808.94,704.59a13.77,13.77,0,0,0-9.92,5.27c.37-11.62,4.71-15.5,10.23-15.5a11.35,11.35,0,0,1,7.73,3.49l6-6.87a19.77,19.77,0,0,0-14.47-5.91c-10.48,0-20.08,8.36-20.08,26.87,0,17.43,9.13,24.65,18.73,24.65,9.07,0,16.55-6.31,16.55-16.68s-6.3-15.32-14.78-15.32M807,728c-3.42,0-6.73-2.52-7.78-10.37,2.29-3.55,5-4.86,7.55-4.86,3.75,0,6.48,2,6.48,7.13C813.21,725.55,810.41,728,807,728Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#45444b",
    d: "M847.13,685.07c-10.65,0-17.75,8.69-17.75,25.55s7.1,26,17.75,26,17.8-9.09,17.8-26-7.13-25.55-17.8-25.55m0,42.64c-3.82,0-6.85-3.52-6.85-17.09s3-16.66,6.85-16.66,6.9,3,6.9,16.66S851,727.71,847.13,727.71Z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 16.62,
    height: 26.78,
    x: 550.58,
    y: 547.86,
    fill: "#ef6928"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 16.62,
    height: 26.78,
    x: 550.58,
    y: 592.02,
    fill: "#e7c25b"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 16.62,
    height: 26.8,
    x: 550.58,
    y: 636.21,
    fill: "#9eb445"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 29.18,
    height: 8.68,
    x: 606.59,
    y: 645.25,
    fill: "#45444b"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#45444b",
    d: "M611.26,649.59l5.73-9.4-.33-.21-15.32,6.1c-5.33,1.15-10.66,2.34-16,3.51,5.32,1.17,10.65,2.37,16,3.53l15.32,6.07.33-.13Z"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 7.6,
    height: 18.12,
    x: 603.18,
    y: 521.65,
    fill: "#45444b"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 7.63,
    height: 18.12,
    x: 614.01,
    y: 521.65,
    fill: "#45444b"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 7.63,
    height: 18.12,
    x: 624.84,
    y: 521.65,
    fill: "#45444b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 418.86,
    height: 289.75,
    x: 2039.87,
    y: 628.52,
    fill: "url(#b)"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2350.75,818c-4.83,5.89-9.82,11.71-14.9,17.42l-43.94-.3h0a8.75,8.75,0,0,1-8.41-6.55l-16-61.55L2242,859.42a8.75,8.75,0,0,1-16.94,0l-13.68-52.53-11.94,20.34a8.76,8.76,0,0,1-8,5.07l-34.17-.24c-4.61-5.29-9.14-10.68-13.51-16.14a8.73,8.73,0,0,1,4.88-1.45l37.9.27L2207,779.87a8.72,8.72,0,0,1,16,2.2h0l10.77,41.33,25.47-92.5a8.75,8.75,0,0,1,16.94.23l22.54,86.54Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#272869",
    fillRule: "evenodd",
    d: "M749.07,1847H2436.43c4.09,0,7.44,2.31,7.44,5.14s-3.35,5.13-7.44,5.13H749.07c-4.09,0-7.43-2.31-7.43-5.13s3.34-5.14,7.43-5.14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManHeart);
export default __webpack_public_path__ + "static/media/manHeart.60a3655f56c7fcbe27bd6fa8cbe4ea47.svg";
export { ForwardRef as ReactComponent };